import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { SidenavService } from '@app/core/services/container/sidenav.service';
import { CustomOverlayDescriptor } from '@app/shared/services/overlay/custom-overlay.service';
import { DataTableNewComponent } from '@components/data/data-table-new/data-table-new.component';
import { EntitySelectionModel } from '@components/data/data-table-new/entitySelectionModel';

@Component({
  selector: 'vfs-stringtable-data',
  templateUrl: './stringtable-data.component.html',
  styleUrls: ['./stringtable-data.component.scss']
})
export class StringtableDataComponent implements OnInit {
  @Input() title: string;
  @Input() dataTableTemplate: TemplateRef<DataTableNewComponent<any>>;
  @Input() closeSidenav = true;
  @Output() accepted = new EventEmitter();
  @Output() cancelled = new EventEmitter();
  @Output() closed = new EventEmitter();

  @Input() disabledSelectButton = false;
  @Input() disabledCancelButton = false;

  @Input() singleSelection: boolean;
  @Input() selection: EntitySelectionModel<any>;
  @Input() customOverlayDescriptor: CustomOverlayDescriptor;

  @Input() hiddenActions = false;

  constructor(protected sidenavService: SidenavService) {}

  ngOnInit() {
    if (this.singleSelection && !this.selection.isMultipleSelection()) {
      this.selection.changed.asObservable().subscribe(_ => {
        this.accept();
      });
    } else if (this.singleSelection) {
      console.warn('If you want to use the simpleSelection, the multiSelect of the selection must be false');
    }
  }

  close() {
    if (this.customOverlayDescriptor && this.customOverlayDescriptor.customDrawer) {
      this.customOverlayDescriptor.customDrawer.close();
    } else {
      this.sidenavService.closeSidenav();
    }
    this.closed.emit();
  }

  cancel() {
    this.cancelled.emit();
    if (this.closeSidenav) {
      this.close();
    }
  }

  accept() {
    this.accepted.emit();
    if (this.closeSidenav) {
      this.close();
    }
  }
}
